import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    dialogPaper: {
      borderRadius: 16,
      paddingTop: '1.5rem',
    },
    iconWrap: {
      width: 64,
      height: 64,
      borderRadius: '50%',
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(17, 98, 254, 0.1)',
    },
    icon: {
      fontSize: 34,
      color: '#1162FE',
    },
    title: {
      textAlign: 'center',
      fontSize: '1.2rem',
      fontWeight: 700,
      color: '#1f2937',
      marginTop: '0.9rem',
    },
    content: {
      paddingTop: '0.4rem',
      paddingBottom: '0.5rem',
    },
    message: {
      textAlign: 'center',
      fontSize: '0.95rem',
      color: '#6b7280',
      marginBottom: 0,
    },
    actionsContainer: {
      justifyContent: 'center',
      gap: '12px',
      padding: '0.5rem 1.5rem 1.75rem',
    },
    noBtn: {
      textTransform: 'none',
      fontWeight: 600,
      borderRadius: 10,
      minWidth: 110,
    },
    yesBtn: {
      textTransform: 'none',
      fontWeight: 600,
      borderRadius: 10,
      minWidth: 110,
    },
  };
});
